export default function postWorkflowMessage(status) {
  if (!window?.parent) {
    // eslint-disable-next-line no-console
    console.error('Missing window parent');
    return;
  }
  window.parent.postMessage({ status }, '*');
}
